import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './App.css';

import Registration from './registration/Registration';
import CaptchaGate from './captchaGate/CaptchaGate';
import PageHeader from './common/PageHeader';

function App() {
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        const isVerified = localStorage.getItem("captcha_verified") === "true";
        const expiry = localStorage.getItem("captcha_verified_expiry");

        if (isVerified && expiry) {
            const isExpired = Date.now() > parseInt(expiry, 10);

            if (!isExpired) {
                setVerified(true);
            } else {
                // Expired — cleanup
                localStorage.removeItem("captcha_verified");
                localStorage.removeItem("captcha_verified_expiry");
                setVerified(false);
            }
        }
    }, []);

    const handleVerified = () => {
        const expiryTimestamp = Date.now() + 12 * 60 * 60 * 1000; // 24 hours
        localStorage.setItem("captcha_verified", "true");
        localStorage.setItem("captcha_verified_expiry", expiryTimestamp.toString());
        setVerified(true);
    };

    return (
        <BrowserRouter>
            <PageHeader />
            {!verified ? (
                <CaptchaGate onVerified={handleVerified} />
            ) : (
                <>
                    <Routes>
                        <Route path="/" element={<Registration />} />
                        <Route path="/:key" element={<Registration />} />
                    </Routes>
                    <Toaster position="top-right" reverseOrder={false} />
                </>
            )}
        </BrowserRouter>
    );
}

export default App;